import { NumberFormatter } from '@repo/toolkit/number'
import { useNavigator } from '@repo/toolkit/use-navigator'
import Badge from '@repo/ui/badge'
import { Column } from '@repo/ui/data-table'
import { GoalIcon, PlusIcon } from '@repo/ui/icons'
import { useRef } from 'react'

import { API } from '../../../api/apis.config'
import DynamicDataTable, { DynamicTableRef } from '../../../components/elements/dynamic-table'
import UserNavBar from '../../../components/elements/nav-bar'
import { QualificationTags } from '../../../components/elements/qualification-badge'
import { Paths } from '../../../lib/constants/path'
import { missionTypeEnumMapping } from '../../../lib/types/enums/mission/mission-type.enum'
import { missionTypeAvailabilityEnumMapping } from '../../../lib/types/enums/mission/mission-type-availability.enum'
import { MissionType } from '../../../lib/types/models/mission-type/mission-type'

export function MissionsListPage() {
  const { navigate, navigateWithEvent } = useNavigator()
  const tableRef = useRef<DynamicTableRef<MissionType>>(null)

  const columns: Column<MissionType>[] = [
    {
      accessorKey: 'type',
      header: 'Catégorie',
      enableSorting: true,
      cell: ({ row }) => missionTypeEnumMapping[row.original.type].label
    },
    {
      accessorKey: 'title',
      header: 'Libellé',
      enableSorting: true
    },
    {
      accessorKey: 'qualifications',
      header: 'Qualifications requises',
      enableSorting: false,
      cell: ({ row }) => <QualificationTags qualifications={row.original.qualifications} />
    },
    {
      accessorKey: 'pay',
      header: 'Rémunération (€)',
      enableSorting: true,
      cell: ({ row }) => {
        const pay = row.original.pay
        return pay ? (
          <Badge variant={'primary'} text={NumberFormatter.roundToTwoDecimalPlaces(pay)} />
        ) : (
          '-'
        )
      }
    },
    {
      accessorKey: 'requiredAvailability',
      header: 'Disponibilité requise',
      enableSorting: true,
      cell: ({ row }) => {
        const availability = row.original.requiredAvailability
        return !availability ? '-' : missionTypeAvailabilityEnumMapping[availability]
      }
    }
  ]

  return (
    <div>
      <UserNavBar title={'Types de mission'} icon={GoalIcon} />
      <div className={'h-4'} />

      <DynamicDataTable<MissionType>
        selectable
        ref={tableRef}
        title={'Tous les types de mission'}
        deleteMessage={{ name: 'type de mission', attributeName: 'title' }}
        endpoint={API.missionTypes.getAll.url}
        columns={columns}
        allowSearchParam
        onRowClick={(mt, event) => {
          navigateWithEvent(Paths.MISSION_TYPE_UPDATE_PAGE.replace(':id', mt.id.toString()), event)
        }}
        actions={[
          {
            type: 'global',
            icon: PlusIcon,
            refetch: true,
            variant: 'primary',
            label: 'Ajouter un nouveau type de mission',
            fn: () => navigate(Paths.MISSION_TYPE_CREATE_PAGE)
          }
        ]}
      />
    </div>
  )
}
